import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, HostBinding } from '@angular/core';
var NglInternalDatatableHeadCell = (function () {
    function NglInternalDatatableHeadCell() {
        this.onSort = new EventEmitter();
    }
    Object.defineProperty(NglInternalDatatableHeadCell.prototype, "header", {
        get: function () {
            return this.headingTpl || this.heading;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NglInternalDatatableHeadCell.prototype, "ariaSort", {
        get: function () {
            return this.sortOrder ? this.sortOrder + "ending" : null;
        },
        enumerable: true,
        configurable: true
    });
    NglInternalDatatableHeadCell.prototype.sortChange = function () {
        this.onSort.emit(this.sortOrder === 'desc' ? 'asc' : 'desc');
    };
    NglInternalDatatableHeadCell.decorators = [
        { type: Component, args: [{
                    selector: 'th[ngl-internal-datatatable-head]',
                    template: "\n    <div class=\"slds-truncate\" *ngIf=\"!sortable\" [attr.title]=\"heading\" [nglInternalOutlet]=\"header\"></div><a class=\"slds-th__action slds-text-link--reset\" *ngIf=\"sortable\" (click)=\"sortChange()\"> <span class=\"slds-assistive-text\">Sort Column</span><span class=\"slds-truncate\" [attr.title]=\"heading\" [nglInternalOutlet]=\"header\"></span><div class=\"slds-icon_container\" title=\"Sort Column\"><svg class=\"slds-icon slds-icon--x-small slds-icon-text-default slds-is-sortable__icon\" nglIcon=\"arrowdown\"></svg></div></a>\n  ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: {
                        'scope': 'col',
                        '[class.slds-is-sorted--asc]': "sortOrder === 'asc'",
                        '[class.slds-is-sorted--desc]': "sortOrder === 'desc'",
                        '[class.slds-is-sorted]': "!!sortOrder",
                    },
                },] },
    ];
    /** @nocollapse */
    NglInternalDatatableHeadCell.ctorParameters = function () { return []; };
    NglInternalDatatableHeadCell.propDecorators = {
        'heading': [{ type: HostBinding, args: ['attr.title',] }, { type: Input },],
        'headingTpl': [{ type: Input },],
        'sortable': [{ type: HostBinding, args: ['class.slds-is-sortable',] }, { type: Input },],
        'sortOrder': [{ type: Input },],
        'ariaSort': [{ type: HostBinding, args: ['attr.aria-sort',] },],
        'onSort': [{ type: Output },],
    };
    return NglInternalDatatableHeadCell;
}());
export { NglInternalDatatableHeadCell };
//# sourceMappingURL=_head.js.map